import type { NuxtApp } from '#app'
import type { LocationQuery } from '#vue-router'

const DEFAULT_QUERY_PARAMS = ['lob', 'start_date', 'end_date']

export default defineNuxtPlugin((nuxtApp) => {
  // `nuxtApp` is typed as `_NuxtApp` which is an internal type that doesn't receive augmented `NuxtApp` type (../types/nuxt-app.d.ts)
  const { $router } = nuxtApp as NuxtApp

  $router.paramKeys = computed(() => Object.keys(useRoute().query))

  $router.hasUrlParam = (key) => {
    const { query } = useRoute()

    return !!query[key]
  }

  $router.getUrlParam = (key) => {
    const { query } = useRoute()

    return query[key] || null
  }

  $router.getUrlParams = (keys = []) => {
    const { query } = useRoute()

    return !keys?.length
      ? query
      : keys.reduce((acc, key) => {
          acc[key] = query[key] || null

          return acc
        }, {} as LocationQuery)
  }

  $router.setUrlParam = (key, value) => {
    const { query } = useRoute()

    return $router.replace({
      query: {
        ...query,
        [key]: value,
      },
    })
  }

  $router.setUrlParams = (query) => {
    const { query: currentQuery } = useRoute()

    return $router.replace({
      query: {
        ...currentQuery,
        ...query,
      },
    })
  }

  $router.removeUrlParam = (key) => {
    const query = { ...useRoute().query }

    delete query[key]

    return $router.replace({ query })
  }

  $router.removeUrlParams = (keys) => {
    const query = { ...useRoute().query }

    for (const key of keys) {
      delete query[key]
    }

    return $router.replace({ query })
  }

  $router.clearUrlParams = (except = []) => {
    const query = { ...useRoute().query }

    for (const key in query) {
      if (!except.concat(DEFAULT_QUERY_PARAMS).includes(key)) {
        delete query[key]
      }
    }

    return $router.replace({ query })
  }
})
